import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Responsive } from '~/components';
import { HeaderProvider } from '~/context';
import BrowserWarningModal from '~/components/BrowserWarningModal';
import { Mobile, Desktop } from './responsive';

const PrivateLayout = ({ children, navBar, subHeader, footer }) => {
  const {
    selectedMatch: { loading: isFetchingMatch },
  } = useSelector(state => state.matches);

  const location = useLocation();
  const clonedNavBar = navBar ? React.cloneElement(navBar, { location }) : null;
  return (
    <HeaderProvider>
      <Responsive
        sm={
          <Mobile
            navBar={clonedNavBar}
            subHeader={subHeader}
            location={location}
            footer={footer}
            isFetching={isFetchingMatch}
          >
            {children}
          </Mobile>
        }
        lg={
          <Desktop
            navBar={clonedNavBar}
            subHeader={subHeader}
            location={location}
            footer={footer}
            isFetching={isFetchingMatch}
          >
            {children}
            <BrowserWarningModal />
          </Desktop>
        }
      />
    </HeaderProvider>
  );
};

PrivateLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]).isRequired,
  navBar: PropTypes.node,
  subHeader: PropTypes.node,
  footer: PropTypes.node,
};

PrivateLayout.defaultProps = {
  navBar: false,
  subHeader: {},
  footer: null,
};

export default PrivateLayout;
